import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, Stack, Typography, } from '@mui/material';
// import { signIn, type SignInInput } from 'aws-amplify/auth';
import { Auth } from 'aws-amplify';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { passwordValidator } from '@mcn-platform/models';
import AuthDialog from './AuthDialog';
import FormStack from '../form/FormStack';
import PasswordField from '../form/PasswordField';
import SubmitButton from '../form/SubmitButton';
import TextField from '../form/TextField';
const forgotPasswordValidator = Yup.object().shape({
    email: Yup.string().email('Email address is required.').required('Email address is required.'),
    newPassword: Yup.string().when('step', {
        is: 'CONFIRM',
        then: passwordValidator(),
    }),
    newPasswordConfirm: Yup.string().when('step', {
        is: 'CONFIRM',
        then: Yup.string().oneOf([Yup.ref('newPassword'), null], 'Passwords must match.').required('Confirm Password is required.'),
    }),
    confirmationCode: Yup.string().when('step', {
        is: 'CONFIRM',
        then: Yup.string().required('Confirmation code is required.'),
    }),
    step: Yup.string(),
});
// @ts-expect-error resolver
const resolver = yupResolver(forgotPasswordValidator);
const ForgotPassword = ({ open, showSignIn, showSignUp, handleClose, }) => {
    const [state, setState] = useState('START');
    const [message, setMessage] = useState();
    const { handleSubmit, control, reset, setValue, formState: { isValid }, } = useForm({
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        defaultValues: {
            email: '',
            newPassword: '',
            newPasswordConfirm: '',
            confirmationCode: '',
            step: 'START',
        },
        resolver,
    });
    const setStep = (step) => {
        setState(step);
        setValue('step', step);
    };
    const close = () => {
        handleClose();
        reset();
        setMessage('');
        setStep('START');
    };
    const handleForgotPassword = async ({ email }) => {
        try {
            await Auth.forgotPassword(email);
            setMessage('An email with the verification code has been sent to your email address.');
            setStep('CONFIRM');
        }
        catch (exception) {
            console.log('error signing in', exception);
            setMessage(exception.message);
            setStep('START');
        }
    };
    const handleConfirm = async ({ email, newPassword, confirmationCode }) => {
        try {
            await Auth.forgotPasswordSubmit(email, confirmationCode, newPassword);
            reset();
            setMessage('');
            setStep('SUCCESS');
            const user = await Auth.signIn({ username: email, password: newPassword });
            console.log('Auto sign-in user', user);
            reset();
            close();
        }
        catch (exception) {
            console.log('error resetting password', exception);
            setMessage(exception.message);
            setStep('CONFIRM');
        }
    };
    let fields;
    let actions;
    let submit;
    const showSignInButton = false;
    const showSignUpButton = false;
    if (state === 'START') {
        fields = (_jsxs(FormStack, { children: [message && (_jsx(Typography, { variant: "h6", children: message })), _jsx(TextField, { label: "Email", name: "email", control: control, required: true, autocomplete: "email" })] }));
        actions = (_jsx(SubmitButton, { label: "Get Code", disabled: !isValid }));
        // showSignInButton = true;
        // showSignUpButton = true;
        submit = handleSubmit(handleForgotPassword);
    }
    else if (state === 'CONFIRM') {
        fields = (_jsxs(FormStack, { children: [message && (_jsx(Typography, { variant: "h6", children: message })), _jsx(TextField, { label: "Verification Code", name: "confirmationCode", control: control, required: true, autocomplete: "one-time-code" }, "confirmationCode"), _jsx(PasswordField, { label: "New Password", name: "newPassword", control: control, required: true, autocomplete: "new-password" }, "newPassword"), _jsx(PasswordField, { label: "Confirm Password", name: "newPasswordConfirm", control: control, required: true, autocomplete: "off" }, "newPasswordConfirm")] }));
        actions = (_jsx(SubmitButton, { label: "Reset Password", disabled: !isValid }));
        submit = handleSubmit(handleConfirm);
    }
    else if (state === 'SUCCESS') {
        fields = (_jsx(Typography, { variant: "body1", children: "Your password has been reset." }));
        actions = null;
        submit = () => { };
    }
    else {
        fields = (_jsx(Typography, { variant: "body1", children: "There was an error resetting the password. Please contact your administrator." }));
        actions = null;
        submit = () => { };
    }
    const extraActions = (_jsxs(Stack, { direction: "row", width: 1, p: 3, spacing: 2, children: [showSignInButton && (_jsx(Button, { onClick: showSignIn, className: "site-system-button-secondary", fullWidth: true, children: "Sign In" })), showSignUpButton && (_jsx(Button, { onClick: showSignUp, className: "site-system-button-secondary", fullWidth: true, children: "Sign Up" }))] }));
    return (_jsx(AuthDialog, { open: open, handleSubmit: submit, handleClose: close, title: "Password Reset", formFields: fields, formActions: actions, extraActions: extraActions }));
};
export default ForgotPassword;
//# sourceMappingURL=ForgotPassword.js.map